// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"5d54edfb","156":"9275ef29","457":"dad30fd3","551":"1a63b37a","821":"ddd436b0","828":"2dcca473","851":"2acc33b3"}[chunkId] + ".chunk.js";
};